import { css } from '@emotion/react';
import { alpha } from '@mui/material/styles';

const makeStoreListStyles = ({ theme }) => {
  return {
    messageContainer: css({
      maxWidth: 640,
      margin: '20px auto',
      textAlign: 'center',
    }),
    listContainer: css({
      maxWidth: 640,
      margin: '0 auto',
    }),
    // Store cards scroll (invisible scrollbar) within a JS-computed max-height
    // (see useOlbScrollMaxHeight) so the heading + view tabs stay visible.
    cardScrollArea: css({
      minHeight: 0,
      overflowY: 'auto',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      '&::-webkit-scrollbar': { display: 'none' },
    }),
    heading: css({
      marginTop: 10,
      '& h6': {
        fontWeight: 900,
        fontSize: 30,
        lineHeight: 1,
      },
    }),
    postcode: css({
      margin: '10px 0 15px 0',
    }),
    viewToggle: css({
      display: 'flex',
      backgroundColor: theme.mvf.palette.background.secondaryBackgroundColor,
      borderRadius: '6px',
      padding: 4,
      marginBottom: 15,
    }),
    viewToggleTab: css({
      flex: 1,
      color: theme.mvf.palette.text.primaryTextColor,
      textTransform: 'none',
      fontWeight: theme.mvf.typography.weight.thick,
      borderRadius: '6px',
    }),
    viewToggleTabActive: css({
      backgroundColor: theme.mvf.palette.background.widgetBackgroundColor,
      '&:hover': {
        backgroundColor: theme.mvf.palette.background.widgetBackgroundColor,
      },
    }),
    storeCard: css({
      backgroundColor: theme.mvf.palette.background.widgetBackgroundColor,
      border: 'solid',
      borderWidth: theme.mvf.border.width.thin,
      borderColor: theme.mvf.palette.component.answerUnselectedColor,
      borderRadius: '6px',
      padding: 15,
      marginBottom: 10,
      textAlign: 'left',
    }),
    // The currently-selected store keeps a thicker theme-coloured border (also
    // persisted when returning from the slot picker).
    storeCardSelected: css({
      borderWidth: 2,
      borderColor: theme.mvf.palette.component.answerSelectedColor,
    }),
    storeCardHeader: css({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 10,
    }),
    storeName: css({
      '& p': {
        fontWeight: theme.mvf.typography.weight.thick,
      },
    }),
    storeDistance: css({
      backgroundColor: alpha(
        theme.mvf.palette.component.answerSelectedColor,
        0.15
      ),
      borderRadius: '12px',
      padding: '2px 10px',
      flexShrink: 0,
      '& p': {
        color: theme.mvf.palette.component.answerSelectedColor,
        fontWeight: theme.mvf.typography.weight.thick,
      },
    }),
    storeAddress: css({
      margin: '5px 0 10px 0',
      textAlign: 'left',
      '& p': { textAlign: 'left' },
    }),
    addressPin: css({
      width: 12,
      height: 12,
      marginRight: 4,
      verticalAlign: 'middle',
    }),
    selectButtonContainer: css({
      height: 45,
      textAlign: 'center',
    }),
  };
};

export default makeStoreListStyles;
